/**
 * Marks the roots of unregistered Alpine components with x-ignore so Alpine
 * skips their subtree.
 *
 * Alpine tolerates an x-data expression it cannot resolve: it falls back to an
 * empty scope and keeps walking descendants, which strips their x-cloak while
 * leaving x-show unevaluable. Elements hidden only by `[x-cloak] {display:none}`
 * — the shared bottom-sheet root in components/ui.twig among them — would then
 * paint as a full-screen overlay on a page with no working handler to dismiss
 * it. Skipping the subtree keeps x-cloak in place, so a component whose chunk
 * failed to load stays invisible rather than becoming an obstruction.
 */
export function ignoreComponentRoots(names, root) {
    const container = root || (typeof document !== 'undefined' ? document : null);

    if (!container || !names || !names.length) {
        return;
    }

    container.querySelectorAll('[x-data]').forEach((element) => {
        const expression = (element.getAttribute('x-data') || '').trim();

        // Match the component name as invoked (`modSettings({...})`) or bare
        // (`modSettings`), never as a prefix of a longer name.
        const matches = names.some((name) => expression === name || expression.startsWith(`${name}(`));

        if (matches) {
            element.setAttribute('x-ignore', '');
        }
    });
}
